/* import __COLOCATED_TEMPLATE__ from './mobile-preview-switcher.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();